import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import React from 'react'

import styles from './PortConfiguration.css'

import {useBoolean} from 'src/hooks/useSlice'

type Props = {
  className?: string
  value?: string
  error?: boolean
  placeholder?: string
  isLoading?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const PortConfiguration: React.FC<Props> = React.memo(
  ({className, value, error, placeholder, isLoading, onChange}) => (
    <div className={className}>
      <div>{'Port'}</div>
      <div className={styles.port}>
        <Input
          type={'number'}
          placeholder={placeholder}
          size={Size.AUTO}
          value={value}
          error={error ? '' : null}
          onChange={onChange}
          disabled={isLoading}
          autoComplete={'off'}
        />
        {isLoading && (
          <div>
            <LoaderInline />
          </div>
        )}
      </div>
      <div className={styles.error}>{error && 'Incorrect port number'}</div>
    </div>
  ),
)
PortConfiguration.displayName = 'PortConfiguration'

const MIN_PORT_VALUE = 1
const MAX_PORT_VALUE = 65535
export const usePortConfiguration = (defaultPort = '443') => {
  const [value, setValue] = React.useState(defaultPort)
  const [error, showError, hideError] = useBoolean(false)

  React.useEffect(() => {
    setValue(defaultPort)
  }, [defaultPort])

  const onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      hideError()
      setValue(e.currentTarget.value)
    },
    [hideError],
  )

  const validate = React.useCallback(() => {
    const numValue = Number(value)

    if (
      value.length > 0 &&
      (!Number.isInteger(numValue) || numValue < MIN_PORT_VALUE || numValue > MAX_PORT_VALUE)
    ) {
      showError()
      return false
    }

    return true
  }, [value, showError])

  const portConfigurationProps = {
    value,
    error,
    onChange,
    placeholder: defaultPort,
  }

  return {
    value,
    error,
    validate,
    portConfigurationProps,
    PortConfiguration,
  }
}
